// @ts-nocheck
import { I18n } from '@lingui/core'
import { Trans } from '@lingui/react'

import { TENANT_IT } from 'shared/consts'
import {
  CART_STICKY_CTA_EXPERIMENT,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { useGetExperimentPerTenant } from 'shared/experiments/utils/tenantBasedExperimentsUtils'
import { withI18n } from 'shared/utils/withI18n'
import Button from 'views/components/atoms/Button'
import { BUTTON_ON_SUBMIT_ANIMATION_STYLES } from 'views/components/atoms/Button/consts'
import IconButtonArrowRight from 'views/components/atoms/Icon/IconButtonArrowRight'
import NotificationBlock from 'views/components/organisms/Cart/NotificationBlock'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

const CartHeader = ({
  submitButtonAction,
  productAmount,
  hasODS,
  providerData,
  disableSubmitButton = false,
  i18n,
}: {
  submitButtonAction: () => void
  productAmount: number
  hasODS: boolean
  providerData: unknown
  disableSubmitButton: boolean
  i18n: I18n
}) => {
  const { tenant } = usePublicConfig()
  const stickyCtaExperiment = useGetExperimentPerTenant(
    CART_STICKY_CTA_EXPERIMENT
  )
  return (
    <div className="l-content__row--fullWidth u-background-color--greySky u-padding--bottom u-padding--top u-margin-x-large--bottom o-Cart__header o-Cart__header-free-shipping-indicator">
      <div className="l-content a-full-width l-flex l-flex--distribute-space u-padding-large--left u-padding-large--right o-Cart__header-container">
        <h2 className="u-no-margin o-Cart__title">
          <Trans
            id="cart.headline"
            values={{
              numberOfProductsInCart: productAmount,
            }}
          />
        </h2>

        {stickyCtaExperiment.isEnabled &&
        stickyCtaExperiment.variant === EXPERIMENT_VARIATION.V1 ? null : (
          <div className="o-Cart--flex-grow o-Cart__button-container">
            <Button
              onClick={submitButtonAction}
              name="toCheckout"
              type="submit"
              style="buttonGhost"
              disabled={disableSubmitButton}
              id="ToCheckoutTop"
              data-loading-label={i18n._('button.loading.label')}
              data-submit-styles={
                BUTTON_ON_SUBMIT_ANIMATION_STYLES.rebrandingBorderedButton
              }
            >
              {/** Note: the span is necessary to make width calculations in isFormSubmitting possible! */}
              <span className="o-Cart__button-label">
                <Trans id="cart.button.label.toCheckoutShort" />
                {tenant === TENANT_IT && (
                  <IconButtonArrowRight className="a-icon--button-arrow-right" />
                )}
              </span>
            </Button>
          </div>
        )}
      </div>
      <div className="u-padding--bottom">
        <NotificationBlock hasODS={hasODS} providerData={providerData} />
      </div>
    </div>
  )
}

export default withI18n()(CartHeader)
